import styled from "styled-components";

export const LayoutContainer = styled.div`
  display: flex;

  .main {
    margin-left: 20%;
    width: 80%;
    height: 100vh;
  }
`;
